<!--
 * @Description: 公司级菜单管理
 * @Author:
 * @Date: 2022-12-28 11:41:16
 * @LastEditTime: 2023-05-08 11:27:27
 * @LastEditors: guohongyuan
 * @Usage:
-->

<template>
  <div>
    <header>
      菜单名称：
      <el-input
        v-model="moduleName"
        placeholder="请输入模块名称"
        style="width: 340px"
        clearable
      ></el-input>
      状态：
      <el-select
        v-model="moduleStatus"
        clearable
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="null"
        > </el-option>
        <el-option
          label="启用"
          value="true"
        > </el-option>
        <el-option
          label="禁用"
          value="false"
        > </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getList"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd"
      >新增</el-button>
    </header>
    <el-table
      height="760"
      max-height="800"
      :data="tableData"
      style="width: 100%; margin-top: 20px"
      border
      :header-cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column
        prop="menuName"
        label="菜单名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="菜单图标"
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="baseUrl + scope.row.menuImg"
            class="home-img"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="order"
        label="菜单排序"
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="模块配置"
        align="left"
        width="580"
      >
        <template slot-scope="scope">
          <div
            class="moduleType"
            v-for="(item, index) in scope.row.childList"
            :key="index"
          >
            {{ item.moduleName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.state == true ? "启用" : "禁用" }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="tc" style="margin-top: 20px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div> -->
    <el-dialog
      :title="editId ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        :rules="rules"
      >
        <el-col>
          <el-form-item
            label="菜单名称:"
            prop="menuName"
          >
            <el-input v-model="form.menuName"></el-input> </el-form-item></el-col>
        <el-col><el-form-item
            label="菜单图标:"
            prop="menuImg"
          >
            <el-input v-model="form.menuImg"></el-input>
            <el-upload
              style="display: inline-block"
              action=""
              :auto-upload="true"
              :http-request="uploadImg"
              :file-list="fileList"
              :before-upload="beforeAvatarUpload"
              :on-change="handleChange"
              list-type="picture"
              :on-remove="handleRemove"
            >
              <el-button
                size="small"
                type="primary"
              >上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            label="菜单排序:"
            prop="order"
          >
            <el-input v-model="form.order"></el-input> </el-form-item></el-col>
        <el-col><el-form-item label="模块配置:">
            <el-button
              @click="addClick"
              type="primary"
            >添加</el-button>
          </el-form-item>
        </el-col>

        <el-col style="max-height: 300px; overflow: auto">
          <el-form-item
            v-for="domain in form.childList"
            :key="domain.order"
          ><el-input
              v-model="domain.order"
              style="width: 15%"
            ></el-input>
            <el-input
              v-model="domain.moduleName"
              style="width: 50%; margin: 0 10px"
            ></el-input>
            <i
              class="el-icon-delete"
              style="cursor: pointer"
              @click.prevent="removeDomain(domain)"
            ></i>
          </el-form-item>
        </el-col>
        <el-col><el-form-item label="状态:">
            <el-radio
              v-model="form.state"
              :label="true"
            >启用</el-radio>
            <el-radio
              v-model="form.state"
              :label="false"
            >禁用</el-radio>
          </el-form-item>
        </el-col>
      </el-form>
      <el-dialog
        append-to-body
        :visible.sync="selectVisible"
        title="模块配置"
        center
        :before-close="selectClose"
        width="800px"
      >
        <el-button
          type="primary"
          @click="sureClick"
        >确定</el-button>
        <el-table
          :data="listData"
          style="width: 100%; margin-top: 20px"
          border
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          max-height="700"
        >
          <el-table-column
            type="selection"
            width="50"
          > </el-table-column>
          <el-table-column
            prop="moduleName"
            label="模块名称"
          >
          </el-table-column>
          <el-table-column label="模块图片">
            <template slot-scope="scope">
              <img
                :src="baseUrl + scope.row.moduleImg"
                class="home-img"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="模块状态"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.isDelete == 0 ? "启用" : "禁用" }}
            </template>
          </el-table-column>
          <el-table-column
            label="模块权限"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.moduleLevel == 0 ? "项目" : "公司" }}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="submitForm('form')"
        >确定</el-button>
        <el-button @click="resetForm('form')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

  <script>
import { provinceAndCityData } from "element-china-area-data";
import { Api_SuperAdmin, Api_Base } from "@/api/api";
import { BASE_PLATFORMLOGO_URL } from "@/util/constant";
export default {
  data() {
    return {
      options: provinceAndCityData,
      selectedOptions: [],
      multipleSelection: [],
      searchKey: "",
      status: null,
      menuName: "",
      tableData: [],
      listData: [],
      addDialogVisible: false,
      selectVisible: false,
      form: {
        indexCompanyMenuId: 0,
        menuName: "", // 模块名称
        order: "", // 模块排序
        menuImg: "", // 模块图片地址
        state: true, //  1 禁用  0启用
        childList: [
          //   {
          //     value: "",
          //     key: "",
          //   },
        ],
      },
      rules: {
        menuName: [
          {
            required: true,
            message: "请输入菜单名称",
            trigger: "blur",
          },
        ],
        order: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
        menuImg: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        // component: [
        //   {
        //     required: true,
        //     message: "请选择模块组件",
        //     trigger: "blur",
        //   },
        // ],
      },
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      operateList: [],
      fileList: [],
      editId: 0,
      moduleName: "",
      moduleStatus: null,
      moduleLevel: -1,
      baseUrl: BASE_PLATFORMLOGO_URL,
      selection: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getDataModule() {
      const params = {
        pageSize: 9999,
        pageIndex: 1,
        name: "",
        isDelete: 0,
        moduleLevel: 1,
      };
      Api_SuperAdmin.getHomeList(params).then((res) => {
        const { data } = res;
        if (data.statusCode === 200) {
          this.listData = data.data.tList;
          this.form.childList.forEach((e) => {
            this.listData.forEach((ele, index) => {
              if (ele.moduleName === e.moduleName) {
                this.listData.splice(index, 1);
              }
            });
          });
        }
      });
    },
    removeDomain(item) {
      var index = this.form.childList.indexOf(item);
      if (index !== -1) {
        this.form.childList.splice(index, 1);
      }
    },
    addClick() {
      this.selectVisible = true;
      this.getDataModule();
      // this.selection = this.form.childList;
    },
    selectClose() {
      this.selectVisible = false;
      this.multipleSelection.forEach((ele, index) => {
        this.form.childList.push({
          moduleName: ele.moduleName,
          moduleId: ele.id,
          order: index + 1,
        });
      });
    },
    sureClick() {
      this.selectClose();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    uploadImg(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then((res) => {
        if (res.data.data[0].fileUrl) {
          this.form.menuImg = res.data.data[0].fileUrl;
          this.$message({
            type: "success",
            message: "上传成功!",
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      const typeArr = ["image/png", "image/gif", "image/jpeg", "image/jpg"];
      const isJPG = typeArr.indexOf(file.type) !== -1;
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("只能上传图片!");
      }
      if (!isLt3M) {
        this.$message.error("上传头像图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.form.menuImg = "";
    },
    handleClose() {
      this.resetForm("form");
    },
    openAdd() {
      this.addDialogVisible = true;
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.fileList = [];
      this.clear();
    },
    clear() {
      this.form = {
        indexCompanyMenuId: 0,
        menuName: "", // 模块名称
        order: "", // 模块排序
        menuImg: "", // 模块图片地址
        state: true, //  1 禁用  0启用
        childList: [
          //   {
          //     value: "",
          //     key: "",
          //   },
        ],
      };
    },
    edit(item) {
      this.fileList = [];
      this.editId = item.indexCompanyMenuId;
      Api_SuperAdmin.detailMenuCom(item.indexCompanyMenuId).then((res) => {
        if (res.data.data) {
          this.form = JSON.parse(JSON.stringify(res.data.data));
          this.form.childList = [];
          res.data.data.childList.forEach((ele) => {
            this.form.childList.push({
              moduleName: ele.moduleName,
              moduleId: ele.indexCompanyMenuId,
              order: ele.moduleSort,
            });
          });
          this.fileList.push({ url: BASE_PLATFORMLOGO_URL + res.data.data.menuImg });
          this.addDialogVisible = true;
        } else {
          this.$message({
            type: "error",
            message: "获取数据失败",
          });
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.addDialogVisible = false;
      // this.$refs[formName].resetFields();
      this.editId = 0;
    },
    del(item) {
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_SuperAdmin.delMenuCom(item).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      let item = this.form;
      // console.log(this.form.childList, "this.form.childList");
      let index = this.form.childList.findIndex((ele) => {
        return ele.order === "";
      });
      let orderArr = [];
      if (index === -1) {
        this.form.childList.forEach((ele) => {
          orderArr.push(parseInt(ele.order));
        });
        let arr2 = Array.from(new Set(orderArr));
        if (arr2.length < orderArr.length) {
          this.$message({
            type: "error",
            message: "模块排序重复！",
          });
        } else {
          Api_SuperAdmin.editMenuCom(item).then((res) => {
            if (res.data.data) {
              this.$message({
                type: "success",
                message: "更新成功!",
              });
              this.addDialogVisible = false;
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "更新失败",
              });
            }
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "有模块排序为空！",
        });
      }
    },
    getList() {
      const params = {
        menuName: this.moduleName,
        state: this.moduleStatus,
      };
      Api_SuperAdmin.getData(params).then((res) => {
        const { data } = res;
        if (data.statusCode === 200) {
          this.tableData = data.data;
          //   this.totalCount = data.data.totalCount;
        }
      });
    },
    // handleSizeChange(size) {
    //   this.pagesize = size;
    //   this.getList();
    // },
    // handleCurrentChange(currentPage) {
    //   this.currentPage = currentPage;
    //   this.getList();
    // },
    handleClick(val) {
      this.form.parentId = val.id;
      this.addDialogVisible = true;
    },
  },
};
</script>
  <style lang="scss" scoped>
.home-img {
  height: 55px;
}
.moduleType {
  padding: 5px 10px;
  margin: 5px;
  background: #7f7f7f;
  display: inline-block;
  border-radius: 6px;
}
</style>